/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { SyncRunResultDTO } from "./SyncRunResultDTO";
import { SyncRunResultDTOFromJSON, SyncRunResultDTOFromJSONTyped, SyncRunResultDTOToJSON } from "./SyncRunResultDTO";

/**
 *
 * @export
 * @interface PaginatedRunsDTO
 */
export interface PaginatedRunsDTO {
  /**
   *
   * @type {Array<SyncRunResultDTO>}
   * @memberof PaginatedRunsDTO
   */
  items: Array<SyncRunResultDTO>;
  /**
   * Total runs matching the filters (authoritative for pagination).
   * @type {number}
   * @memberof PaginatedRunsDTO
   */
  total: number;
  /**
   *
   * @type {number}
   * @memberof PaginatedRunsDTO
   */
  limit: number;
  /**
   *
   * @type {number}
   * @memberof PaginatedRunsDTO
   */
  offset: number;
}

/**
 * Check if a given object implements the PaginatedRunsDTO interface.
 */
export function instanceOfPaginatedRunsDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "items" in value;
  isInstance = isInstance && "total" in value;
  isInstance = isInstance && "limit" in value;
  isInstance = isInstance && "offset" in value;

  return isInstance;
}

export function PaginatedRunsDTOFromJSON(json: any): PaginatedRunsDTO {
  return PaginatedRunsDTOFromJSONTyped(json, false);
}

export function PaginatedRunsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedRunsDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    items: (json["items"] as Array<any>).map(SyncRunResultDTOFromJSON),
    total: json["total"],
    limit: json["limit"],
    offset: json["offset"]
  };
}

export function PaginatedRunsDTOToJSON(value?: PaginatedRunsDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    items: (value.items as Array<any>).map(SyncRunResultDTOToJSON),
    total: value.total,
    limit: value.limit,
    offset: value.offset
  };
}
